import greenAnimationData from "../../../assets/animations/lottie-loader.json";
import transparentAnimationData from "../../../assets/animations/transparent-loader.json";
import lottie from "lottie-web";
import { useEffect, useRef } from "react";

function AnimationPage(props) {
  const variant = props?.variant || "default";
  const animationData =
    variant === "transparent" ? transparentAnimationData : greenAnimationData;

  const styles = {
    containerStyle: {
      height: props?.height || "150px",
      transform: "translate(-5%, 5%)",
      ...props.style,
    },
  };

  const lottieRef = useRef();
  useEffect(() => {
    lottie.loadAnimation({
      container: lottieRef.current,
      animationData,
    });
    return () => {
      lottie.destroy();
    };
  }, []);
  return <div ref={lottieRef} style={styles.containerStyle}></div>;
}

export default AnimationPage;
